import React from "react";
import { PageHeader } from "@/components/ui-blocks/PageHeader";
import { MembershipForm } from "@/components/forms/MembershipForm";
import { DigitalMembershipCard } from "@/components/DigitalMembershipCard";
import { SEO } from "@/lib/seo";
import { CheckCircle2, ShieldCheck, Award, BookOpen } from "lucide-react";

export default function MembershipPage() {
  return (
    <main>
      <SEO title="Digital Membership" description="Activate your CAF Digital Membership and get a digital ID card, training access and recognition badges." breadcrumbs={[{name: "Home", href:"/"},{name:"Membership", href:"/membership"}]} />
      <PageHeader eyebrow="Digital Membership" title="Your citizenship, digitised." lead="Free CAF Digital Membership gives you a digital ID card, training access, and recognition as you grow." />
      <section className="container-wide py-12 grid gap-10 lg:grid-cols-12">
        <div className="lg:col-span-7">
          <div className="rounded-2xl border border-border bg-background p-6"><MembershipForm /></div>
        </div>
        <aside className="lg:col-span-5 space-y-6">
          <DigitalMembershipCard member={{ full_name: "Your Name", city: "Your City", member_id: "CAF-26-DEMO", membership_type: "Individual" }} />
          <div className="grid grid-cols-2 gap-3">
            {[[CheckCircle2, "Free forever"],[Award, "Badges & recognition"],[BookOpen, "Training modules"],[ShieldCheck, "Verified digital ID"]].map(([Icon, t]) => (
              <div key={t} className="rounded-xl border border-border bg-background p-4 flex items-start gap-3"><Icon className="h-5 w-5 text-[hsl(var(--green))]" /><div className="text-sm font-semibold text-foreground">{t}</div></div>
            ))}
          </div>
        </aside>
      </section>
    </main>
  );
}
